export interface CrmReportingBuPath {
  company: string | null;
  businessUnit: string | null;
  segment: string | null;
  division: string | null;
  region: string | null;
  district: string | null;
}

/**
 * Parses a CRM reporting business unit path into its component levels.
 * Nodes in the path are delimited by "->".
 * 
 * Path node indices:
 * - 0 = Company
 * - 1 = Business Unit
 * - 2 = Segment
 * - 3 = Division
 * - 4 = Region
 * - 5 = District
 * 
 * @param path The CRM reporting path string, or null/undefined
 * @returns An object with properties for each path level; properties are null if the path doesn't contain enough nodes
 */
export function parseCrmReportingBuPath(
  path: string | null | undefined
): CrmReportingBuPath {
  const result: CrmReportingBuPath = {
    company: null,
    businessUnit: null,
    segment: null,
    division: null,
    region: null,
    district: null,
  };

  if (!path || typeof path !== "string") {
    return result;
  }

  const nodes = path.split("->").map((node) => node.trim());

  if (nodes.length > 0 && nodes[0]) result.company = nodes[0];
  if (nodes.length > 1 && nodes[1]) result.businessUnit = nodes[1];
  if (nodes.length > 2 && nodes[2]) result.segment = nodes[2];
  if (nodes.length > 3 && nodes[3]) result.division = nodes[3];
  if (nodes.length > 4 && nodes[4]) result.region = nodes[4];
  if (nodes.length > 5 && nodes[5]) result.district = nodes[5];

  return result;
}
